<template>
    <coupon-base :discount="discount">
        <template slot-scope="{ formattedPercentage, formattedAmount, removeCoupon }">
            <div class="card">
                <div class="card-body">
                    <button
                        class="btn btn-sm btn-danger"
                        style="float: right"
                        @click="removeCoupon(discount.code)"
                    >
                        X
                    </button>
                    <p>{{ discount.name }}</p>
                    <div>
                        {{ __('Code: :code', {code: discount.code }) }}
                    </div>
                    <div>
                        {{ __('Discount: :percentage% (:value)', { value: formattedAmount, percentage: formattedPercentage }) }}
                    </div>
                </div>
            </div>
        </template>
    </coupon-base>
</template>

<script>
export default {
    name: 'PercentCoupon',
    props: {
        discount: {
            type: Object,
            required: true
        }
    }
}
</script>